export const languages: Record<string, string> = {
    en: "English",
    ru: "русский",
    ua: "Українська",
};